import Editor, { EditorProps } from "@monaco-editor/react";
import React from "react";

import useMonaco from "../hooks/use-monaco";
import { useSettings } from "../hooks/use-settings";
import LoadingScreen from "./LoadingScreen";

const defaultOptions: EditorProps["options"] = {
  lineNumbersMinChars: 2,
  minimap: {
    enabled: false,
  },
  overviewRulerBorder: false,
  overviewRulerLanes: 0,
  scrollBeyondLastLine: false,
};

type TextEditorProps = React.PropsWithChildren<EditorProps>;
export const TextEditor = (props: TextEditorProps) => {
  const settings = useSettings();
  const { loading, error } = useMonaco();
  const { options, ...remainingProps } = props;

  if (error) {
    return <div>Failed to initialize editor: {error?.message || error}</div>;
  }

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Editor
      height="40vh"
      options={{ ...defaultOptions, ...options }}
      theme={settings.paletteMode}
      {...remainingProps}
    />
  );
};
export default TextEditor;
